import { FAQPage, WithContext } from 'schema-dts';

import { DEFAULT_STRUCTURE } from '../constants';

export type FaqMapperParams = {
  items: {
    title: string;
    content: string;
  }[];
};

export const faqMapper = ({
  items,
}: FaqMapperParams): WithContext<FAQPage> => ({
  ...DEFAULT_STRUCTURE,
  '@type': 'FAQPage' as const,
  mainEntity: items.map((item) => ({
    '@type': 'Question' as const,
    name: item.title,
    acceptedAnswer: {
      '@type': 'Answer' as const,
      text: item.content,
    },
  })),
});
